export default {"src":"/_next/static/media/quiz-dream-yard.f9975d4b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};